import { defineMessages } from 'react-intl';
import globalIntl from 'globalIntl'; // eslint-disable-line import/no-unresolved

const m = defineMessages({
  constr: {
    id: 'constr',
    defaultMessage: 'Constructor',
  },
  preview: {
    id: 'preview',
    defaultMessage: 'Preview',
  },
  saveAsTemplate: {
    id: 'saveAsTemplate',
    defaultMessage: 'Save as template',
  },
  formSteps: {
    id: 'formSteps',
    defaultMessage: 'Step 1 of 2',
  },
});

export default { ...globalIntl, ...m };
